module.exports = __webpack_public_path__ + "static/media/files-selected.e61a94eb.svg";